// src/pages/about/About.tsx
import React from "react";
import styles from "./About.module.scss";
import { useTheme } from "../../common/hooks/useTheme";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";
import { hasAboutPage, getAbout } from "../../config/runtimeConfig";

export const About: React.FC = () => {
  const { theme } = useTheme();

  if (!hasAboutPage()) return null;

  const about = getAbout();

  return (
    <div className={styles.container} style={{ backgroundColor: theme.background }}>
      <PageMeta />
      <ProductHeader
        title="О нас"
        isFavorite={false}
        showFavorite={false}
        textColor={theme.text}
        borderColor={theme.border}
      />

      <div className={styles.content}>
        {/* HERO */}
        <div className={styles.hero}>
          {about.heroImage && (
            <div className={styles.heroImageWrap}>
              <img
                src={about.heroImage}
                alt={about.heroImageAlt || about.title}
                className={styles.heroImage}
                loading="eager"
              />
            </div>
          )}

          <h1 className={styles.heading} style={{ color: theme.text }}>
            {about.title}
          </h1>

          {about.intro && (
            <div className={styles.intro} style={{ color: theme.textSecondary }}>
              {about.intro}
            </div>
          )}
        </div>

        {/* SECTIONS */}
        {about.sections.map((section, i) => (
          <div key={i} className={styles.section}>
            <h2 className={styles.sectionTitle} style={{ color: theme.text }}>
              {section.title}
            </h2>

            {section.image && (
              <div className={styles.sectionImageWrap}>
                <img
                  src={section.image}
                  alt={section.title}
                  className={styles.sectionImage}
                  loading="lazy"
                />
              </div>
            )}

            <div className={styles.paragraph} style={{ color: theme.text }}>
              {section.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};